import { getSupporterCSVList } from '@/api/community';

export default {
  namespaced: true,
  state: {
    loading: false,
  },
  mutations: {
    setLoading(state, isLoading) {
      state.loading = isLoading;
    },
  },
  actions: {
    async getSupporterList({ commit, dispatch }) {
      try {
        commit('setLoading', true);
        const { data } = await getSupporterCSVList();
        dispatch('csv/downloadCSV', { csv: data, filename: 'foodtryb_my-supporters.csv' }, { root: true });
      } catch (e) {
        dispatch('errorOverlay/setMessage', e, { root: true });
        throw e;
      } finally {
        commit('setLoading', false);
      }
    },
  },
  getters: {
    loading: state => state.loading,
  },
};
